import { ApplicationAssignee } from '../Models/ApplicationAssignee';

export function assigneeIsInterlocutor(interlocutorIds?: string[], applicationAssignee?: ApplicationAssignee): boolean {
  const applicationAssigneeGroupId = applicationAssignee?.group?.id;
  if (!interlocutorIds || !applicationAssigneeGroupId) return false;

  return interlocutorIds.includes(applicationAssigneeGroupId);
}
